import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
const Footer = () => (
  <footer className="border-t border-white/10 mt-32 bg-ink-surface" data-testid="footer">
    <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16 grid gap-12 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3">
          <Logo size={30} />
          <span className="font-bebas text-2xl tracking-[0.14em]">PEOPLE'S CIRCLE</span>
        </div>
        <p className="mt-5 max-w-md text-sm text-white/50 leading-relaxed">
          A civic energy network. Debate policy, sign petitions, show up at events, and back the
          people building things in your city.
        </p>
      </div>
      <div>
        <h4 className="text-[12px] font-bold uppercase tracking-[0.2em] text-neon">Participate</h4>
        <div className="mt-4 grid gap-2 text-sm text-white/60">
          <Link to="/events" className="hover:text-white transition-colors">Events</Link>
          <Link to="/petitions" className="hover:text-white transition-colors">Petitions</Link>
          <Link to="/discussions" className="hover:text-white transition-colors">Discussions</Link>
          <Link to="/blogs" className="hover:text-white transition-colors">Blogs</Link>
        </div>
      </div>
      <div>
        <h4 className="text-[12px] font-bold uppercase tracking-[0.2em] text-neon">Circle</h4>
        <div className="mt-4 grid gap-2 text-sm text-white/60">
          <Link to="/spotlight" className="hover:text-white transition-colors">Spotlight</Link>
          <Link to="/fellowship" className="hover:text-white transition-colors">Fellowship</Link>
          <Link to="/dashboard" className="hover:text-white transition-colors">Dashboard</Link>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-6 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-white/40">
          <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
          <Link to="/terms" className="hover:text-white transition-colors">Terms &amp; Conditions</Link>
          <Link to="/refunds" className="hover:text-white transition-colors">Cancellation &amp; Refunds</Link>
          <Link to="/shipping" className="hover:text-white transition-colors">Shipping &amp; Delivery</Link>
          <Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link>
          <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
        </div>
        <div className="text-xs text-white/30">&copy; {new Date().getFullYear()} People's Circle. Built for public energy.</div>
      </div>
    </div>
  </footer>
);
export default Footer;
